var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"products flex items-stretch flex-wrap relative bg-[#FFEF0A]"},[_c('div',{staticClass:"w-full text-center absolute top-[190vw] tablet:top-[110vw] laptop:top-[43vw] desktop:top-[850px] z-30"},[_c('a',{staticClass:"button",attrs:{"href":"https://www.muscador.fr/nos-produits/","target":"_blank"}},[_vm._v("DÉCOUVREZ NOS PRODUITS")])])])
}]

export { render, staticRenderFns }